import React, { useMemo } from 'react';

import { Carousel } from 'components/carousel/Carousel';
import { IconsEnum } from 'components/Icons';
import { Skeleton } from 'components/skeleton';
import { SportNewsCard } from 'components/cards/sportNewsCard';
import { SportNewsProps } from '.';
import { Wrapper } from 'components/wrapper';
import { isTruthy } from 'utility/functions';
import { parse } from 'node-html-parser';
import styles from './SportNews.module.scss';
import { useGetSportNewsQuery } from 'features/api/sportApiSlice';
import { useRouter } from 'next/router';

export const SportNews = ({ title, url, isTopTemplate }: SportNewsProps) => {
  const { asPath, isReady } = useRouter();

  const { currentData: data, isLoading } = useGetSportNewsQuery(
    isTopTemplate ? undefined : asPath.replace('/sport/', '').toLowerCase(),
    { skip: !isReady }
  );

  const cards = useMemo(() => {
    return data?.map((item) => {
      const doc = parse(item.description);
      const img = doc.querySelector('img') as HTMLImageElement | null;
      const src = img?.getAttribute('src');
      const alt = img?.getAttribute('alt');
      const p = doc.querySelector('p') as HTMLElement | null;
      return {
        title: item.title,
        image: {
          src,
          alt,
        },
        link: item.link,
        category: item.category,
        description: p?.textContent,
      };
    });
  }, [data]);

  if (!isReady || isLoading) {
    return <Skeleton key={`${title}-${url}`} />;
  }

  if (!isTruthy(cards?.length)) {
    return <React.Fragment key={`${title}-${url}`} />;
  }

  return (
    <Wrapper noPaddingRight noPaddingLeft classNameWrapper={styles.marginTop}>
      <Carousel
        title={title}
        classNameTitle={styles.title}
        url={url}
        cardContainerClassName={styles.cardContainerSportNews}
        iconId={IconsEnum.LINK_EXTERNAL}
        classNameIcon={styles.icon}
      >
        {cards!.map((item, index) => (
          <SportNewsCard
            key={item.title + '_' + index}
            link={item.link}
            title={item.title}
            image={item.image}
            category={item.category}
            description={item.description!}
          />
        ))}
      </Carousel>
    </Wrapper>
  );
};
